class CustomSearch extends HTMLElement {
    connectedCallback() {
        this.searchResultsContainer = this.querySelector(
            '.main-search[data-live-search="true"] .main-search__results'
        )
        this.input = this.querySelector('input[type="text"]')
        this.searchSuggestions = this.querySelector('.main-search__suggestions')

        this.setupEventListeners()
    }

    debounceSearch(func, wait) {
        let timeout;
        return function (...args) {
            clearTimeout(timeout);
            timeout = setTimeout(() => func.apply(this, args), wait);
        };
    }

    setupEventListeners() {
        this.input.addEventListener(
            'input',
            this.debounceSearch((event) => this.onChange(event), 300)
        );

        this.addEventListener('click', (event) => {
            const termEl = event.target.closest('.predefined-search-term');
            if (!termEl) return;

            const term = termEl.textContent.trim();
            if (!term) return;

            // Put term into input
            this.input.value = term;
            this.input.focus();

            // Reuse existing logic by triggering the input event
            const inputEvent = new Event('input', { bubbles: true });
            this.input.dispatchEvent(inputEvent);
        });
    }

    getQuery() {
        return this.input.value.trim()
    }

    onChange() {
        const searchTerm = this.getQuery()
        if (!searchTerm.length) {
            this.searchResultsContainer.innerHTML = ''
            this.searchSuggestions.style.display = 'block'
            return
        }
        // this.hidePreviousSearches()

        this.getSearchResults(searchTerm)
    }

    // Track search with klaviyo
    klaviyoTrack(searchTerm, results) {
        _learnq.push([
            'track',
            'Searched Site',
            {
                SearchTerm: searchTerm,
                ReturnedResults: results,
            },
        ])
    }

    showSpinner() {
        this.searchResultsContainer.innerHTML = `
        <div class="main-search__results-spinner">
            <div class="loading-spinner"></div>
        </div>
    `;
    }

    renderSearchResults(resultsMarkup, predictiveHits, semanticHits) {
        this.searchResultsContainer.innerHTML = resultsMarkup
        predictiveHits > 0 || semanticHits > 0 ? this.searchSuggestions.style.display = 'none' : this.searchSuggestions.style.display = 'block'
        this.setAttribute('results', true)
    }

    // Search function
    getSearchResults = async (searchTerm) => {
        // Construct the search URL
        let searchFetchProductURL = `/search?section_id=api-search-results&type=product&q=${encodeURIComponent(searchTerm)}`;
        let searchFetchArticleURL = `/search?section_id=api-search-results&type=article&q=${encodeURIComponent(searchTerm)}`;
        let searchFetchPageURL = `/search?section_id=api-search-results&type=page&q=${encodeURIComponent(searchTerm)}`;
        let searchFetchPredictiveURL = `/search/suggest?section_id=api-search-results&q=${encodeURIComponent(searchTerm)}`;

        try {
            // Show loading spinner and hide suggestions
            this.searchSuggestions.style.display = 'none'
            this.showSpinner();

            // Fetch both semantic and predictive search concurrently
            const [semanticProductRes, semanticArticleRes, semanticPageRes, predictiveRes] = await Promise.all([
                fetch(searchFetchProductURL),
                fetch(searchFetchArticleURL),
                fetch(searchFetchPageURL),
                fetch(searchFetchPredictiveURL)
            ]);

            if (!semanticProductRes.ok) throw new Error('Semantic search request failed');
            if (!semanticArticleRes.ok) throw new Error('Semantic search request failed');
            if (!semanticPageRes.ok) throw new Error('Semantic search request failed');
            if (!predictiveRes.ok) throw new Error('Predictive search request failed');

            // Parse semantic HTML
            const parseSection = async (res) => {
                const html = await res.text();
                const doc = new DOMParser()
                    .parseFromString(html, 'text/html')
                    .querySelector('#shopify-section-api-search-results');

                const hitsEl = doc?.querySelector('div[data-search-hits]');
                const hits = hitsEl ? parseInt(hitsEl.dataset.searchHits, 10) : 0;

                return { doc, hits };
            };

            const semanticProducts = await parseSection(semanticProductRes);
            const semanticArticles = await parseSection(semanticArticleRes);
            const semanticPages = await parseSection(semanticPageRes);
            const predictive = await parseSection(predictiveRes);

            // Putting all sections in an array
            const sections = [
                predictive,
                semanticProducts,
                semanticArticles,
                semanticPages,
            ];

            // Building markup from all sections that actually have hits
            const combinedMarkup = sections
                .filter(section => section && section.hits > 0)
                .map(section => section.doc.innerHTML)
                .join('');

            // Setting resultsmarkup accordingly
            const resultsMarkup =
                combinedMarkup ||
                `<div>${theme.strings.general_quick_search_no_results}</div>`;

            const semanticHits =
                semanticProducts.hits +
                semanticArticles.hits +
                semanticPages.hits;

            // Render combined markup
            this.renderSearchResults(resultsMarkup, predictive.hits, semanticHits);

        } catch (error) {
            console.error(`Error fetching products for search term ${searchTerm}:`, error);
            return null;
        }

    };
}

customElements.define('custom-search', CustomSearch)